/**
 * 门户中文文案（统一配置，避免业务字面量散落）。
 */
export const PortalMessages = {
    APP_SUBTITLE: '登录后加入或发起会议',
    PASSWORD_LOGIN: '账号密码',
    SMS_LOGIN: '手机验证码',
    PHONE: '手机号',
    PHONE_PLACEHOLDER: '请输入 11 位手机号',
    DISPLAY_NAME: '显示名称',
    DISPLAY_NAME_PLACEHOLDER: '可选',
    PASSWORD: '密码',
    PASSWORD_PLACEHOLDER: '至少 6 位',
    SMS_CODE: '验证码',
    SMS_CODE_PLACEHOLDER: '短信验证码',
    SEND_SMS: '获取验证码',
    SMS_COOLDOWN_SUFFIX: 's',
    /** 短信通道未对接时的开发提示（前端静态文案，接真实短信后可移除） */
    SMS_NOT_CONNECTED_TIP: '短信通道暂未对接，开发环境验证码默认为 1111',
    LOGIN: '登录',
    REGISTER: '注册',
    SUBMITTING: '提交中…',
    LOGOUT: '退出登录',
    /** 头像按钮无障碍/悬停提示（对齐 Electron userSettings.openMenu） */
    OPEN_ACCOUNT_MENU: '账号菜单',
    AGREE_PREFIX: '我已阅读并同意',
    AND: '和',
    TERMS: '服务协议',
    PRIVACY: '隐私政策',
    NEED_AGREE: '请先同意服务协议与隐私政策',
    INVALID_PHONE: '手机号格式不正确',
    SEND_SMS_FAILED: '发送验证码失败',
    LOGIN_FAILED: '登录失败',
    GO_REGISTER: '没有账号？去注册',
    GO_LOGIN: '已有账号？去登录',
    OTHER_METHODS: '其他登录方式',
    WECHAT_SOON: '微信（即将支持）',
    SSO_LOGIN: '办办单点登录',
    SSO_REDIRECTING: '正在跳转办办登录…',
    SSO_SCAN_HINT: '请使用办办扫一扫，手机上点「同意授权」。授权成功后由电脑跳回门户。',
    SSO_BACK_ACCOUNT: '使用账号登录',
    SSO_ERR_NOT_CONFIGURED: '办办 SSO 未配置，请联系管理员',
    SSO_ERR_DENIED: '办办未完成授权。登录后请勾选权限并点击「同意授权」，不要点「拒绝」',
    SSO_ERR_STATE: '登录状态已失效，请重新点击办办 SSO',
    SSO_ERR_TOKEN: '办办换票失败，请稍后重试',
    SSO_ERR_PHONE: '办办账号未绑定有效手机号',
    SSO_ERR_TICKET: '登录凭证已失效，请重新使用办办登录',
    SSO_ERR_GENERIC: '办办登录失败，请稍后重试',
    SSO_ERR_DISABLED: '账号已禁用',
    SSO_ERR_DELETED: '账号已注销',
    JOIN_MEETING: '加入会议',
    QUICK_MEETING: '快速会议',
    SCHEDULE_MEETING: '预定会议',
    CREATE_MEETING: '创建会议',
    CREATE_TITLE: '会议名称',
    CREATE_TITLE_PLACEHOLDER: '请输入会议名称',
    CREATE_MEETING_NO: '会议号',
    CREATE_MEETING_NO_PLACEHOLDER: '不填则自动生成',
    CONFIRM_CREATE: '创建会议',
    CREATE_REQUIRED: '请填写会议名称',
    UPCOMING: '即将开始',
    ALL_MEETINGS: '全部会议',
    ALL_MEETINGS_TITLE: '全部会议',
    /** 首页分区：进行中 */
    ONGOING_SECTION_TITLE: '正在进行中的会议',
    /** 首页分区：已预定 */
    SCHEDULED_SECTION_TITLE: '预定的会议',
    NO_TITLE: '未命名会议',
    MEETING_SCHEDULED: '已预定',
    MEETING_ONGOING: '进行中',
    MEETING_ENDED: '已结束',
    MEETING_DETAIL: '会议详情',
    MEETING_PENDING: '待开始',
    MEETING_JOINED: '已入会',
    MEETING_SHARE: '分享',
    MEETING_SHARE_COPIED: '邀请信息已复制',
    MEETING_TODAY: '今天',
    LOAD_MORE: '加载更多',
    LOADING_MORE: '加载中…',
    NO_MEETINGS: '暂无会议',
    ENTER_MEETING: '进入',
    DELETE_MEETING: '删除',
    CONFIRM_DELETE: '确定删除该会议吗？删除后无法恢复。',
    MEETING_NO: '会议号',
    MEETING_NO_PLACEHOLDER: '请输入会议号',
    MEETING_NO_REQUIRED: '请填写会议号',
    MEETING_NO_INCOMPLETE: '请输入完整的会议号',
    YOUR_NAME: '您的名称',
    REMEMBER_JOIN_NAME: '当前设备始终使用此名称入会',
    ENABLE_MIC: '开启麦克风',
    ENABLE_SPEAKER: '开启扬声器',
    ENABLE_VIDEO: '开启视频',
    CONFIRM_JOIN: '加入会议',
    CANCEL: '取消',
    CLOSE: '关闭',
    SCHEDULE_TITLE: '会议主题',
    SCHEDULE_TOPIC: '主题',
    SCHEDULE_START: '开始时间',
    SCHEDULE_START_SHORT: '开始',
    SCHEDULE_DURATION: '时长',
    SCHEDULE_DURATION_LONG: '会议时长',
    SCHEDULE_HINT: '预约时长仅作日程安排，到点后会议不会自动结束。',
    SCHEDULE_TYPE_TITLE: '请选择会议类型',
    SCHEDULE_TYPE_REGULAR: '常规会议',
    SCHEDULE_NEXT: '下一步',
    SCHEDULE_DONE: '完成',
    SCHEDULE_TIMEZONE: '时区',
    SCHEDULE_TIMEZONE_BEIJING: '(GMT+08:00) 中国标准时间 - 北京',
    SCHEDULE_REPEAT: '重复频率',
    SCHEDULE_REPEAT_NONE: '不重复',
    SCHEDULE_PARTICIPANTS: '参会人',
    SCHEDULE_ADD: '添加',
    SCHEDULE_CALENDAR: '日历',
    SCHEDULE_WAITING_ROOM: '等候室',
    SCHEDULE_JOIN_PASSWORD: '入会密码',
    SCHEDULE_PASSWORD_PLACEHOLDER: '请输入入会密码',
    SCHEDULE_REGISTRATION: '开启会议报名',
    SCHEDULE_JOIN_BEFORE_HOST: '允许成员在主持人前入会',
    SCHEDULE_WATERMARK: '会议水印',
    SCHEDULE_WATERMARK_OFF: '未开启',
    SCHEDULE_MULTI_DEVICE: '允许成员多端入会',
    SCHEDULE_BLOCK_ADD_CONTACT: '禁止互相添加联系人',
    SCHEDULE_AUTO_TRANSCRIPT: '自动文字转写',
    SCHEDULE_DOCUMENTS: '文档',
    SCHEDULE_ALLOW_UPLOAD_DOC: '允许成员上传文档',
    SCHEDULE_POLL: '投票',
    SCHEDULE_APPS: '应用',
    SCHEDULE_VIRTUAL_BG: '统一虚拟背景',
    SCHEDULE_NOT_SET: '未设置',
    SCHEDULE_MORE: '更多',
    SCHEDULE_PICK_END_TIME: '选择结束时间',
    SCHEDULE_END_TIME: '结束时间',
    SCHEDULE_HOUR_UNIT: '时',
    SCHEDULE_MINUTE_UNIT: '分',
    SCHEDULE_HOUR_LABEL: '小时',
    SCHEDULE_MINUTE_LABEL: '分钟',
    SCHEDULE_TODAY: '今天',
    SCHEDULE_MUTE: '静音',
    SCHEDULE_MUTE_ON_ENTRY: '成员入会时静音',
    SCHEDULE_MUTE_ON: '开启',
    SCHEDULE_MUTE_OFF: '关闭',
    SCHEDULE_MUTE_AFTER_6: '超过6人后自动开启',
    SCHEDULE_RECORDING: '录制',
    SCHEDULE_AUTO_RECORD: '自动云录制',
    SCHEDULE_CLEAR_TITLE: '清空主题',
    SCHEDULE_END: '结束时间（可选）',
    CONFIRM_SCHEDULE: '预定',
    SCHEDULE_REQUIRED: '请填写主题与开始时间',
    HISTORY: '历史会议',
    HISTORY_SEARCH_PLACEHOLDER: '会议名称、会议备注、会议号、发起人',
    NO_HISTORY: '暂无历史记录',
    HISTORY_BACK: '返回',
    HISTORY_MORE: '更多',
    HISTORY_REFRESH: '刷新',
    HISTORY_MEETING_NO: '会议号',
    HISTORY_COPY: '复制',
    HISTORY_COPIED: '已复制',
    HISTORY_ORGANIZER: '发起人',
    HISTORY_PARTICIPANTS: '已参会',
    HISTORY_PEOPLE: '人',
    HISTORY_TIME: '时间',
    HISTORY_LAST_JOIN: '最近入会',
    HISTORY_DURATION: '参会时长',
    HISTORY_AI_NOTES: 'AI纪要',
    HISTORY_AI_DEVICE_ONLY: '仅本设备可见',
    HISTORY_NO_NOTES: '暂无纪要',
    HISTORY_AI_OVERVIEW: '会议概览',
    HISTORY_AI_FINAL: '总纪要',
    HISTORY_AI_DECISIONS: '决议',
    HISTORY_AI_ACTIONS: '待办',
    HISTORY_AI_GENERATED: '内容由 AI 生成',
    HISTORY_REJOIN: '重新入会',
    HISTORY_VIEW_RECORDING: '查看录像',
    HISTORY_ENDED_HINT: '会议已结束',
    LOAD_FAILED: '加载失败',
    ACTION_FAILED: '操作失败',
    MESSAGES: '消息',
    NO_MESSAGES: '暂无消息',
    MARK_ALL_READ: '全部已读',
    EXCHANGING_TOKEN: '正在加载会议信息…',
    EXCHANGE_FAILED: '换票失败，请重试或从门户加入会议',
    /** 同账号已在会中：换票页标题（勿再用「换票失败」笼统提示） */
    ALREADY_IN_MEETING_TITLE: '无法进入会议',
    ADD_CURRENT_DEVICE_CONFIRM: '您已经在其他设备上加入此会议，是否添加当前设备一起入会？',
    DEVICE_LIMIT_EXCEEDED: '多端入会最多支持 3 个设备同时入会，请先退出其他设备后再入会',
    /** 会议已结束：换票页标题（勿再用「换票失败」笼统提示） */
    MEETING_ENDED_TITLE: '会议已结束',
    /** 会议不存在：换票页标题 */
    MEETING_NOT_FOUND_TITLE: '会议不存在',
    MISSING_ROOM: '缺少会议室参数',
    NEED_LOGIN_FIRST: '请先登录后再进入会议',
    INVITE_AI_HOST: 'AI托管',
    INVITE_PHONE_JOIN: '电话入会',
    INVITE_MINI_PROGRAM: '小程序入会',
    INVITE_FEATURE_TODO: '暂未开放',
    INVITE_COPY_HINT_PREFIX: '您可以',
    INVITE_COPY_HINT_LINK: '复制会议邀请',
    INVITE_COPY_HINT_SUFFIX: '，发送至会议成员',
    INVITE_LANG: '简体中文',
    INVITE_APP_NAME: '会议',
    INVITE_TZ_CN: '中国标准时间',
    BUSY: '处理中…',
    SETTINGS: '设置',
    SETTINGS_THEME: '界面主题',
    THEME_LIGHT: '浅色',
    THEME_DARK: '深色',
    THEME_SYSTEM: '跟随系统',
    NAV_MEETING: '会议',
    NAV_RECORDINGS: '录制',
    /** 手机底栏「录像记录」（替代通讯录位） */
    NAV_RECORDINGS_TAB: '录像记录',
    /** 手机底栏「我的」 */
    NAV_PROFILE: '我的',
    PROFILE_TITLE: '我的',
    /** 未对接功能点击提示 */
    PROFILE_FEATURE_TODO: '功能暂未开发',
    /** 头像区：静态套餐标签（当前无后端套餐字段） */
    PROFILE_PLAN_FREE: '免费版',
    /** 头像区：签名占位 */
    PROFILE_SIGNATURE_PLACEHOLDER: '点击设置签名，所有人均可查看',
    /** 头像区：我的资料入口 */
    PROFILE_MY_INFO: '我的资料',
    PROFILE_FIELD_NAME: '名称',
    PROFILE_FIELD_SIGNATURE: '签名',
    PROFILE_SET_BACKGROUND: '点击设置背景图',
    PROFILE_REPLACE_AVATAR: '替换头像',
    PROFILE_SAVE: '保存',
    PROFILE_SAVED: '已保存',
    PROFILE_NAME_REQUIRED: '名称不能为空',
    PROFILE_UPLOAD_FAILED: '图片上传失败',
    PROFILE_IMAGE_TYPE: '请选择图片文件',
    PROFILE_NAME_HINT: '名称将展示给其他参会成员',
    PROFILE_SIGNATURE_HINT: '签名所有人均可查看',
    /** 额度卡标题 */
    PROFILE_QUOTA_TITLE: '您可召开',
    PROFILE_QUOTA_TWO_UNLIMITED: '2人不限时会议',
    PROFILE_QUOTA_EXPAND: '扩容',
    PROFILE_QUOTA_LARGE_LIMITED: '3-100人限时40分钟会议',
    PROFILE_QUOTA_EXTRA_CARDS: '本月剩余加时卡 0 张',
    PROFILE_QUOTA_UPGRADE: '立即升级',
    PROFILE_QUOTA_UPGRADE_HINT: '升级专业版即享不限时会议',
    /** 试用 banner 主文案；副文案沿用 PROFILE_BANNER */
    PROFILE_TRIAL_TITLE: '免费申请商业版/企业版试用',
    /** 「我的」页顶部 banner 文案（对齐参考图，现作试用 banner 副文案） */
    PROFILE_BANNER: '体验安全，稳定，专业的会议服务',
    PROFILE_TOPBAR_THEME: '切换主题',
    PROFILE_TOPBAR_ADD_FRIEND: '添加好友',
    PROFILE_TOPBAR_SCAN: '扫一扫',
    /** 「我的」页 3×2 快捷入口：6 项（与参考图一致） */
    PROFILE_SHORTCUT_PERSONAL_ROOM: '个人会议室',
    PROFILE_SHORTCUT_RECORDINGS: '录制',
    PROFILE_SHORTCUT_NOTES: '我的笔记',
    PROFILE_SHORTCUT_AI: 'AI小助手',
    PROFILE_SHORTCUT_ORDERS: '订单与服务',
    PROFILE_SHORTCUT_CONTROL_ROOMS: '控制Rooms',
    AI_ASSISTANT_TITLE: 'AI小助手',
    AI_ASSISTANT_WELCOME: '你好，我是 AI 小助手。可以直接问我问题。',
    AI_ASSISTANT_PLACEHOLDER: '请输入你的问题',
    AI_ASSISTANT_SEND: '发送',
    AI_ASSISTANT_SENDING: '思考中…',
    AI_ASSISTANT_EMPTY: '请输入问题',
    AI_ASSISTANT_FAILED: '回答失败，请稍后重试',
    /** 「我的」页菜单列表项：6 项 */
    PROFILE_MENU_POINTS: '积分中心',
    /** 「积分中心」右侧额外文案（加时卡、视频 VIP…） */
    PROFILE_MENU_POINTS_EXTRA: '加时卡、视频VIP…',
    PROFILE_MENU_SECURITY: '账号与安全',
    PROFILE_MENU_SETTINGS: '设置',
    PROFILE_MENU_PRIVACY: '隐私',
    PROFILE_MENU_HELP: '帮助与客服',
    PROFILE_MENU_ABOUT: '关于我们',
    /** 关于我们的右侧小红点可达性标签（视觉提示） */
    PROFILE_MENU_ABOUT_DOT_LABEL: '有新版本',
    PROFILE_SECURITY_BIND: '账号绑定',
    PROFILE_SECURITY_UNBOUND: '未绑定手机号',
    PROFILE_SECURITY_PASSWORD: '修改密码',
    PROFILE_SECURITY_PASSWORD_HINT: '验证当前手机号后设置新密码',
    PROFILE_SECURITY_DELETE: '注销账号',
    PROFILE_SECURITY_DELETE_HINT: '申请后 7 天内登录将自动取消',
    PROFILE_NEW_PASSWORD: '新密码',
    PROFILE_CONFIRM_PASSWORD: '确认新密码',
    PROFILE_PASSWORD_MISMATCH: '两次输入的密码不一致',
    PROFILE_PASSWORD_TOO_SHORT: '密码至少 6 位',
    PROFILE_PASSWORD_CHANGED: '密码已修改',
    PROFILE_PASSWORD_SMS_HINT: '验证码将发送至当前绑定手机号',
    PROFILE_DELETE_WARNING: '提交后将退出登录。若 7 天内重新登录，将自动取消注销；7 天未登录，账号将被注销，该手机号可重新注册。',
    PROFILE_DELETE_CONFIRM: '确认注销',
    DELETION_CANCELLED: '已取消账号注销',
    PROFILE_PRIVACY_CONTENT: '隐私政策：我们重视您的隐私保护，仅收集必要数据用于提供服务\n数据使用：会议录制、成员列表等数据仅用于当前会议\n权限管理：可在系统设置中管理麦克风、摄像头等权限',
    PROFILE_HELP_CONTENT: '常见问题：可在「帮助中心」查看常见问题解答\n联系客服：工作时间 9:00-18:00，电话 400-000-0000\n反馈建议：欢迎通过「意见反馈」入口提交建议',
    PROFILE_ABOUT_CONTENT: '产品名称：会议门户\n当前版本：v1.0.0\n公司名称：待补充\n联系方式：待补充',
    RECORDINGS_TITLE: '会议录制',
    RECORDINGS_EMPTY: '暂无录制',
    RECORDINGS_EMPTY_RECENT: '暂无最近浏览',
    RECORDINGS_TAB_ALL: '全部文件',
    RECORDINGS_TAB_RECENT: '最近浏览',
    RECORDINGS_TAB_MINE: '我的录制',
    RECORDINGS_STORAGE_USED: '已使用{used}（共{count}个云端存储文件）',
    RECORDINGS_FILTER_ALL: '所有',
    RECORDINGS_FILTER_SCENE: '录制场景',
    RECORDINGS_FILTER_IN_MEETING: '会中',
    RECORDINGS_FILTER_OUT_MEETING: '会外',
    RECORDINGS_FILTER_TIME: '创建时间筛选',
    RECORDINGS_FILTER_LAST_MONTH: '近1个月',
    RECORDINGS_FILTER_LAST_3_MONTHS: '近3个月',
    RECORDINGS_FILTER_START: '起始时间',
    RECORDINGS_FILTER_END: '终止时间',
    RECORDINGS_FILTER_DATE_PLACEHOLDER: 'yyyy/mm/dd',
    RECORDINGS_FILTER_RESET: '重置',
    RECORDINGS_FILTER_CONFIRM: '确认',
    RECORDINGS_FILTER_EMPTY: '没有符合筛选条件的录制',
    RECORDINGS_VIEW_LIST: '列表视图',
    RECORDINGS_VIEW_GRID: '宫格视图',
    RECORDINGS_SHARE: '复制会议号',
    RECORDINGS_SHARE_COPIED: '已复制会议号',
    RECORDINGS_SHARE_MISSING: '没有可复制的会议号',
    RECORDINGS_MORE: '更多',
    RECORDINGS_END: '已显示所有内容',
    RECORDINGS_PLAY: '播放',
    RECORDINGS_VIEW_SUMMARY: '会议总结',
    RECORDINGS_DELETE: '删除',
    RECORDINGS_CONFIRM_DELETE: '确定删除该录制吗？删除后无法恢复。',
    RECORDINGS_FILE_SIZE: '大小',
    RECORDINGS_CREATED_AT: '时间',
    RECORDINGS_PLAYING: '正在播放',
    RECORDINGS_CLOSE_PLAYER: '关闭播放',
    RECORDINGS_REFRESH: '刷新',
    RECORDINGS_SIDE_TITLE: '会议列表',
    RECORDINGS_SIDE_HINT: '你参与过的会议录制',
    RECORDINGS_FILE_MISSING: '录制文件尚未同步到门户，无法播放',
    RECORDINGS_PLAY_FAILED: '视频加载失败，请刷新列表后重试或联系管理员',
    RECORDINGS_SUMMARY_TITLE: '会议总结',
    RECORDINGS_SUMMARY_CLOSE: '关闭',
    RECORDINGS_SUMMARY_LOADING: '正在加载会议总结…',
    RECORDINGS_SUMMARY_GENERATING: '正在根据录像生成会议总结（非流式转写可能较久）…',
    RECORDINGS_SUMMARY_EMPTY: '尚未生成会议总结，可点击生成',
    RECORDINGS_SUMMARY_MISSING_MEETING_NO: '缺少会议号',
    RECORDINGS_SUMMARY_LOAD_FAILED: '加载会议总结失败',
    RECORDINGS_SUMMARY_OVERVIEW: '概要',
    RECORDINGS_SUMMARY_DECISIONS: '决议',
    RECORDINGS_SUMMARY_ACTIONS: '待办',
    RECORDINGS_SUMMARY_SPEAKERS: '发言人',
    RECORDINGS_SUMMARY_RISKS: '风险点',
    RECORDINGS_SUMMARY_TRANSCRIPT: '全文逐字稿',
    RECORDINGS_SUMMARY_REGENERATE: '重新生成',
    RECORDINGS_SUMMARY_SEEK_HINT: '点击句子可跳转到录像对应时间',
    RECORDINGS_SUMMARY_NEED_FILE: '录制文件不可用，无法生成会议总结',
    RECORDINGS_SUMMARY_FAILED: '会议总结生成失败'
};
